export default __webpack_public_path__ + "static/media/Quiken_Shopify-22.f962899e.svg";